import { Helmet } from 'react-helmet-async'

import { GameList } from '#/components/views/browse-games'
import { useCaptureScreen } from '#/hooks'

import { Back } from '../common/back'
import styles from './games.module.scss'

export const BrowseGamesScreen: React.FC = () => {
  useCaptureScreen('Game Browser')

  return (
    <div className={styles.screen}>
      <Helmet>
        <title>Browse Game - Mavis Hub</title>
      </Helmet>

      <div className={styles.container}>
        <section className={styles.body}>
          <div style={{ marginBottom: 24 }}>
            <Back href="/" />
          </div>
          <GameList />
        </section>
      </div>
    </div>
  )
}
